import { IAlertResponseTime } from "app/models/statistics.model";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { TranslateModule } from "@ngx-translate/core";
import { DeviceTypePipe, MomentPipe, SecondsToReadableFormatPipe } from "app/pipes/pipes";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  AfterViewInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { HelperService } from "app/services/helper.service";
import {
  StatisticsExportSnapshot,
  StatisticsExportWidget,
} from "app/services/statistics-export.models";

@Component({
  selector: "alert-response-times",
  templateUrl: "./alert-response-times.component.html",
  styleUrls: ["./alert-response-times.component.css"],
  standalone: true,
  imports: [
    TranslateModule,
    SecondsToReadableFormatPipe,
    MatTableModule,
    MatSortModule,
    MomentPipe,
    DeviceTypePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertResponseTimesComponent implements OnInit, AfterViewInit, StatisticsExportWidget {
  constructor(private helper: HelperService) {}

  @Input() responseTimes: IAlertResponseTime[];

  @ViewChild(MatSort) sort: MatSort;

  tableData: MatTableDataSource<IAlertResponseTime>;

  displayedColumns: string[] = [
    "timestamp",
    "deviceName",
    "deviceType",
    "deviceId",
    "responseTime",
  ];

  ngAfterViewInit(): void {
    this.tableData.sort = this.sort;
  }

  ngOnInit(): void {
    this.tableData = new MatTableDataSource(this.responseTimes);
  }

  // PNG download is disabled for this list widget; only the PDF export consumes
  // this snapshot, which embeds the structured native table (paginates
  // automatically as vector text).
  async captureForExport(): Promise<StatisticsExportSnapshot | null> {
    return this.buildNativeTableSnapshot();
  }

  private buildNativeTableSnapshot(): StatisticsExportSnapshot {
    const rows = (this.responseTimes ?? []).map((row) => ({
      cells: [
        this.helper.formatDate(row.timestamp, "l LTS"),
        row.deviceName ?? "",
        this.helper.getDeviceType(row.deviceType),
        row.deviceId ?? "",
        this.helper.convertSecondsToReadableFormat(row.responseTime),
      ],
    }));

    return {
      slug: "alert-response-times",
      titleKey: "RESPONSE_TIME_PER_ALERT",
      imageDataUrl: "",
      pdfNativeTable: {
        columns: [
          { headerKey: "TIMESTAMP", align: "left", width: "auto" },
          { headerKey: "DEVICE_NAME", align: "left", width: "*" },
          { headerKey: "DEVICE_TYPE", align: "left", width: "auto" },
          { headerKey: "SERIAL_NUMBER", align: "left", width: "auto" },
          { headerKey: "RESPONSE_TIME_TEXT", align: "right", width: "auto" },
        ],
        rows,
      },
    };
  }
}
